const ArrowIcon = ({
  style = { width: "1.5vh", height: "1.5vh" },
  color = "grey",
  direction = "right", // Default direction is "right"
}) => {
  let rotation = "rotate(0deg)"; // Default is pointing to the right

  // Dynamically set rotation based on direction
  if (direction === "up") {
    rotation = "rotate(90deg)";
  } else if (direction === "down") {
    rotation = "rotate(270deg)";
  } else if (direction === "left") {
    rotation = "rotate(180deg)";
  }

  return (
    <svg
      viewBox="0 0 254.873 371.153"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style, transform: rotation }} // Apply the dynamic rotation
    >
      <path
        d="m83.548 356.898.003.003.101-.102 171.221-171.223-171.223-171.225-.101-.098-.002.001c-19.144-19.037-50.093-19.006-69.195.097-19.104 19.104-19.135 50.054-.097 69.198l-.002.002.098.098 101.929 101.928-101.927 101.928-.098.099.001.002c-19.035 19.144-19.008 50.095.096 69.197 19.103 19.102 50.054 19.134 69.196.095z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowIcon;
